import { HttpClient } from '@angular/common/http';
import { Injectable, Optional, Inject, InjectionToken } from '@angular/core';
import { User, LoginForm, NewUser, ChangePassword, EditUser, ForgotPassword } from './user.types';

export const REQUIRE_ROLE_AUTH = new InjectionToken<boolean>('REQUIRE_ROLE_AUTH');

@Injectable()
export class UserService {
	private readonly userUrl = 'api/me';

	constructor(private _http: HttpClient, @Optional() @Inject(REQUIRE_ROLE_AUTH) private requireRoleAuth: boolean) {}

	login(loginForm: LoginForm): Promise<User> {
		const options = this.requireRoleAuth ? { params: { requireRoleAuth: 'true' } } : {};
		return this._http.post<User>(this.userUrl, loginForm, options).toPromise();
	}

	logout(): Promise<void> {
		return this._http.delete<void>(this.userUrl).toPromise();
	}

	loadUser() {
		const options = this.requireRoleAuth ? { params: { includeRoleAuth: 'true' } } : {};
		return this._http.get<User>(this.userUrl, options).toPromise();
	}

	register(newUser: NewUser): Promise<User> {
		return this._http.put<User>(this.userUrl, newUser).toPromise();
	}

	async isEmailTaken(email: string): Promise<boolean> {
		try {
			await this._http.get(`${this.userUrl}/email/${email}`).toPromise();
			return false;
		} catch (error) {
			return error.status === 500 ? false : true;
		}
	}

	changePassword(changePassword: ChangePassword): Promise<void> {
		return this._http.put<void>(`${this.userUrl}/password`, changePassword).toPromise();
	}

	changeEmail(): Promise<void> {
		return this._http.post<void>(`${this.userUrl}/email`, null).toPromise();
	}

	forgotPassword(email: string): Promise<void> {
		return this._http.get<void>(`${this.userUrl}/password?email=${email}`).toPromise();
	}

	resetForgottenPassword(forgotPassword: ForgotPassword): Promise<User> {
		return this._http.post<User>(`${this.userUrl}/password`, forgotPassword).toPromise();
	}

	updateDetails(editUser: EditUser): Promise<void> {
		return this._http.put<void>(`${this.userUrl}/details`, editUser).toPromise();
	}
}
